import { marketTradePercentages } from '../../../../../constants'

const MarketTradePercentages = ({
  percentages = marketTradePercentages,
  activePercentage,
  onPercentageChange,
  activeColor = 'bg-[#26a69a]',
  className = '',
}) => {
  const percentagesContent = percentages.map((percentage) => {
    const isActive = activePercentage === percentage

    return (
      <button
        key={percentage}
        className={`font-normal text-sm px-[15px] py-[3px] rounded-[5px] transition-colors duration-200 ease ${isActive ? `${activeColor} text-white` : `hover:text-white hover:${activeColor} bg-[#eff2f6] text-[#4a4a4a]`}`}
        onClick={() => onPercentageChange(percentage)}
      >
        {percentage}%
      </button>
    )
  })

  return (
    <div
      className={`w-full flex items-center flex-wrap gap-[7px] mb-[30px] ${className}`}
      role="group"
    >
      {percentagesContent}
    </div>
  )
}

export default MarketTradePercentages
